import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";
import { Button } from "../components/ui/button";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-serif text-xl font-semibold mb-2">{title}</h2>
    <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function CookiePolicy() {
  const openPrefs = () => window.dispatchEvent(new Event("open-cookie-preferences"));
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="cookie-page">
      <Seo title="Cookie Policy | Libri in Circolo" description="Cookie policy di Libri in Circolo (scambiamocelo.it): quali cookie utilizziamo e come gestire le tue preferenze." path="/cookie" />
      <Button asChild variant="ghost" size="sm" className="mb-4"><Link to="/"><ArrowLeft className="w-4 h-4 mr-2" />Torna al sito</Link></Button>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center"><Cookie className="w-6 h-6" /></div>
        <h1 className="text-3xl font-serif font-bold tracking-tight">Cookie Policy</h1>
      </div>
      <p className="text-sm text-muted-foreground">Ai sensi del GDPR (UE 2016/679) e della direttiva ePrivacy. Ultimo aggiornamento: giugno 2026.</p>

      <Section title="1. Titolare">
        <p>Titolare del trattamento: <strong>Paparelli Marco</strong>, Viale Regina Margherita 46, Roma (Italia).</p>
      </Section>

      <Section title="2. Cosa sono i cookie">
        <p>I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente per memorizzare informazioni. Utilizziamo anche tecnologie simili (es. archiviazione locale del browser) per salvare le tue preferenze, incluso il consenso ai cookie.</p>
      </Section>

      <Section title="3. Tipologie di cookie utilizzati">
        <div className="space-y-3">
          <div className="rounded-xl border border-border p-4">
            <p className="font-medium text-foreground">Cookie tecnici / necessari <span className="text-xs font-normal text-muted-foreground">(sempre attivi)</span></p>
            <p>Indispensabili per il funzionamento del sito: gestione dell'autenticazione (token di sessione), sicurezza e memorizzazione delle preferenze sui cookie. Non richiedono consenso.</p>
          </div>
          <div className="rounded-xl border border-border p-4">
            <p className="font-medium text-foreground">Cookie analitici</p>
            <p>Utilizzati, previo consenso, per raccogliere statistiche anonime o aggregate sull'utilizzo del sito, così da migliorarne le funzionalità.</p>
          </div>
          <div className="rounded-xl border border-border p-4">
            <p className="font-medium text-foreground">Cookie di marketing</p>
            <p>Utilizzati, previo consenso, per personalizzare contenuti e comunicazioni. Attualmente non attivi di default.</p>
          </div>
        </div>
      </Section>

      <Section title="4. Gestione del consenso">
        <p>Al primo accesso viene mostrato un banner che consente di <strong>accettare tutti</strong> i cookie, <strong>rifiutare quelli non essenziali</strong> oppure <strong>personalizzare</strong> le preferenze per singola categoria. La tua scelta viene salvata e il banner non ricompare nelle visite successive.</p>
        <p>Puoi modificare o revocare il consenso in qualsiasi momento tramite il pulsante <button onClick={openPrefs} className="text-primary underline" data-testid="cookie-open-prefs">Preferenze cookie</button> (disponibile anche nel footer del sito).</p>
      </Section>

      <Section title="5. Come disabilitare i cookie dal browser">
        <p>È inoltre possibile gestire o eliminare i cookie tramite le impostazioni del proprio browser (Chrome, Firefox, Safari, Edge). La disabilitazione dei cookie tecnici può compromettere il corretto funzionamento del sito.</p>
      </Section>

      <Section title="6. Ulteriori informazioni">
        <p>Per maggiori dettagli sul trattamento dei dati personali consulta la <Link to="/privacy" className="text-primary underline">Privacy Policy</Link>.</p>
      </Section>
    </div>
  );
}
